import { render, staticRenderFns } from "./NieuwsmakerSlide.vue?vue&type=template&id=1e307a16"
import script from "./NieuwsmakerSlide.vue?vue&type=script&lang=js"
export * from "./NieuwsmakerSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e307a16')) {
      api.createRecord('1e307a16', component.options)
    } else {
      api.reload('1e307a16', component.options)
    }
    module.hot.accept("./NieuwsmakerSlide.vue?vue&type=template&id=1e307a16", function () {
      api.rerender('1e307a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/slides/NieuwsmakerSlide.vue"
export default component.exports